"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeSignalName = normalizeSignalName;
const MINUS_LIKE = /[−–—]/g;
const FULLWIDTH_PLUS = /＋/g;
const FOOTNOTE_MARKERS = /[*†‡§¶⁰¹²³⁴⁵⁶⁷⁸⁹]/g;
const PUNCTUATION_PERIOD = /(?<!\d)\.(?!\d)/g;
const SLASH_SPACES = /\s*\/\s*/g;
function normalizeSignalName(name) {
    if (typeof name !== 'string') {
        return name;
    }
    const stripped = name
        .replace(MINUS_LIKE, '-')
        .replace(FULLWIDTH_PLUS, '+')
        .replace(FOOTNOTE_MARKERS, '')
        .replace(PUNCTUATION_PERIOD, '')
        .replace(SLASH_SPACES, '/')
        .trim();
    const signShifted = stripped.length > 1 && (stripped[0] === '+' || stripped[0] === '-') ?
        `${stripped.slice(1)}${stripped[0]}`
        : stripped;
    return signShifted.trim();
}
//# sourceMappingURL=normalize-signal-name.js.map